import { loaderCreator } from '@/vuex/plugins/loaderPlugin/_base'
import mixpanelUtil from '@/utils/mixpanel.utils.js'
import { CONSENT_TYPES, addToConsentCallbackStore } from '@/utils/cookieConsent'

export default loaderCreator(() => {
  addToConsentCallbackStore(CONSENT_TYPES.ANALYTICS, () => {
    mixpanelUtil.init()
  })
})
